<script>
import Vue from 'vue';
import d3 from 'd3';
import nv from 'nvd3';
import BaseChartMixin from '../mixins/base_chart_mixin';
import vMediaQuery from 'v-media-query';
import Permissions from '~/services/permissions/vue_permissions';

Vue.use(Permissions);
Vue.use(vMediaQuery);

export default Vue.component('bar-chart', {

    mixins: [BaseChartMixin],

    props: {
        yAxisLabel: String,

        xAxisLabel: String,

        tickFormat: {
            type: String,
            default: null
        },

        colors: {
            type: Array,
            default() {
                if(this.$hasAccess('DemoDashboard') || this.$hasAccess('NewUI')) {
                    return [
                        '#8E7BDC',
                        '#C9447B',
                        '#EF6A4F',
                        '#FCA24B',
                        '#9EBC68',
                        '#46B695'
                    ]
                }

                return [
                    '#348fe2',
                    '#4a3553',
                    '#00acac',
                    '#ff5b57',
                    '#f59c1a',
                    '#727cb6',
                    '#49b6d6'
                ]
            }
        },

        xValueField: {
            type: String,
            default: 'label'
        },

        yValueField: {
            type: String,
            default: 'value'
        },

        showLegend: {
            type: Boolean,
            default: true
        },

        isStacked: {
            type: Boolean,
            default: true
        },

        showControls: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            chart: () => {}
        }
    },

    computed: {
        computeTickFormat() {
            let format = this.tickFormat;

            if (format === 'currency') {
                format = '$,.2s';
            }

            return format;
        },

        showControlsMobile() {
            return this.$mq.resize && this.$mq.above(415) ? this.showControls : false
        }
    },

    watch: {
        xAxisLabel(value) {
            this.chart.xAxis.axisLabel(this.xAxisLabel);
            this.chart.update();
        }
    },

    // EXAMPLE STACKED BAR CHART DATA
    // [
    //     {
    //     "key": "one",
    //     "values": [
    //         {"x": "AA", "y": 0.2},
    //         {"x": "BB", "y": 0.8},
    //         {"x": "CC", "y": 0.3}
    //         ]
    //     },
    //     {
    //     "key": "two",
    //     "values": [
    //         {"x": "AA", "y": 0.5},
    //         {"x": "BB", "y": 0.4},
    //         {"x": "CC", "y": 0.6}
    //         ]
    //     }
    // ]

    mounted() {
        nv.addGraph(() => {
            this.chart = nv.models.multiBarChart();

            // chart.legend.margin({top: 15, right:0, left:0, bottom: 25});
            // chart.legend.margin({top: 15, right:0, left:0, bottom: 25});

            this.chart.x(d => d[this.xValueField]);
            this.chart.y(d => d[this.yValueField]);

            this.chart.yAxis.axisLabel(this.yAxisLabel);
            this.chart.xAxis.axisLabel(this.xAxisLabel);
            this.chart.multibar.stacked(this.isStacked);
            this.chart.showControls(this.showControlsMobile);
            this.chart.color(this.colors);

            // TODO: hide legend on mobile
            this.chart.showLegend(this.showLegend);

             //Too many bars and not enough room? Try staggering labels.
            // this.chart.staggerLabels(this.staggerLabels);

            //Don't show tooltips
            //this.chart.tooltips(this.tooltips);
            //...instead, show the bar value right on top of each bar.
            // this.chart.showValues(this.showValues);

            if (this.computeTickFormat) {
                this.chart.yAxis.tickFormat(d3.format(this.computeTickFormat));
            }

            this.redraw(this.chart);
            this.chartRef = this.chart;
            nv.utils.windowResize(this.chart.update);

            return this.chart;
        });
    }
})
</script>

<template>
    <div :style="`height: ${this.height}`">
        <svg ref="chart"></svg>
    </div>
</template>